import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fade from 'react-reveal/Fade';

import { ThemeContext } from '../../contexts/ThemeContext';

import expImgWhite from '../../assets/svg/experience/expImgWhite.svg'
import expImgBlack from '../../assets/svg/experience/expImgBlack.svg'

import './Experience.css'

function ExperienceCard({id, company, jobtitle, startYear, endYear}) {

    const { theme } = useContext(ThemeContext);

    const useStyles = makeStyles((t) => ({
        experienceCard : {
            backgroundColor:theme.primary30,
            color: theme.primary,
            "&:hover": {
                backgroundColor:theme.primary50,
                color: 'white'
            },
        },
    }));

    const classes = useStyles();


    return (
        <Fade bottom>
            <div key={id} className={`experience-card ${classes.experienceCard}`}>
                <div className="expcard-img" style={{backgroundColor: theme.primary}}>
                    <img src={expImgWhite} alt="" />
                </div>
                <div className="experience-details">
                    <h6>{startYear}-{endYear}</h6>
                    <h4>{jobtitle}</h4>
                    <h5>{company}</h5>
                </div>
            </div>
        </Fade>   
    )
}

export default ExperienceCard
